import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';

import { apiClient } from 'api/apiClient';
import type { Area } from 'api/types/lookups';
import type { IRequestException } from 'api/types/requestException';

interface IGetStatesResponse {
    cityZipCodes: Area[];
}

export type IGetStatesProps = UseQueryOptions<IRequestException>;

const getStates = async () => {
    const response = await apiClient.get('lookups');

    return (await response.json()) as IGetStatesResponse;
};

export const useGetStatesQuery = (
    options: UseQueryOptions<IGetStatesResponse, IRequestException>
) => {
    return useQuery<IGetStatesResponse, IRequestException>(
        'lookups',
        async () => await getStates(),
        { ...options }
    );
};
